/**
 * Formatuje czas powiadomienia w czytelny sposób
 * @param {string} dateString - Data w formacie ISO string
 * @returns {string} Sformatowany czas
 */
export function formatNotificationTime(dateString) {
  const date = new Date(dateString);
  const now = new Date();
  const diffInSeconds = Math.floor((now - date) / 1000);

  if (diffInSeconds < 60) {
    return 'przed chwilą';
  } else if (diffInSeconds < 3600) {
    const minutes = Math.floor(diffInSeconds / 60);
    return `przed ${minutes} ${minutes === 1 ? 'minutą' : 'minutami'}`;
  } else if (diffInSeconds < 86400) {
    const hours = Math.floor(diffInSeconds / 3600);
    return `przed ${hours} ${hours === 1 ? 'godziną' : 'godzinami'}`;
  } else if (diffInSeconds < 604800) {
    const days = Math.floor(diffInSeconds / 86400);
    return `przed ${days} ${days === 1 ? 'dniem' : 'dniami'}`;
  } else {
    return date.toLocaleDateString('pl-PL', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  }
}
